import { render, staticRenderFns } from "./AddOnSurvey.vue?vue&type=template&id=fa39ee3a&scoped=true"
import script from "./AddOnSurvey.vue?vue&type=script&lang=js"
export * from "./AddOnSurvey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa39ee3a",
  null
  
)

export default component.exports